//Add wallet services here
import TorusSdk from "@toruslabs/customauth";

import {ethers} from "ethers";
import {TransactionRequest} from "@ethersproject/abstract-provider";
import { io, Socket } from 'socket.io-client';
import {WEB_SOCKET_URI, BASE_URL,
        VERIFIER_DICT} from '../constants/constants';
import { loginUserBackend } from './backendHelpers';
import { getInternalProvider } from './internalProviderService';
import {InternalTransactionService} from './internalTransactionService';
import { InternalMessageSigningService } from './internalMessageSigningService';
import { v4 as uuidv4 } from 'uuid';
import { WALLET_INFO_STORAGE_KEY, USER_INFO_STORAGE_KEY, GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY } from '../constants/storage_constats';
import {getNewWallet, customLoginJWT, getSigner,
        customLoginBackend
} from './incomplete_login_handler'

const saveLoginDetails = (loginDetails:any, glipGGToken:any) => {
    localStorage.setItem(
        WALLET_INFO_STORAGE_KEY, JSON.stringify(
            loginDetails));
    localStorage.setItem(
        USER_INFO_STORAGE_KEY, JSON.stringify(
            loginDetails));
    localStorage.setItem(
        GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY,
        JSON.stringify(glipGGToken));
}

function getGlipWalletData(){
    let walletDetails:any = localStorage.getItem(
        USER_INFO_STORAGE_KEY);
    if(!walletDetails){
        return false;
    }
    walletDetails = JSON.parse(walletDetails);
    if(!walletDetails){
        return false;
    }
    return walletDetails;
}

function getGlipUserData(){
    let walletDetails:any = localStorage.getItem(
        USER_INFO_STORAGE_KEY);
    if(!walletDetails){
            return false;
    }
    walletDetails = JSON.parse(walletDetails);
    if(!walletDetails){return false;}
    return walletDetails;
}

// If number ignore
// if string convert to number
// if string hex convert hex to decimal
function convertToNumber(value:any){
    if(typeof value === 'number'){
        return value;
    }
    if(typeof value === 'string'){
        if(value.startsWith('0x')){
            return parseInt(value, 16);
        }
        return parseInt(value);
    }
    return value;
}


function isIframeWindow(){
    if(window.parent !== window){
        return true;
    }
    return false;
}
// TODO: Mixin the marketplace service inside this.
export class WalletService {
    
    chainId?:number;
    clientIdentifier?:string;
    authNetwork:any;
    connectedSocket?:Socket;
    torusdirectsdk: TorusSdk|undefined;
    internalTransactionService?:InternalTransactionService;
    internalMessageSigningService?:InternalMessageSigningService;
    isInitialized:boolean=false;
    isMobileSDK: boolean=false;
    socketUUID:string='';
    isHashedMessage:boolean=false;
    
    async init({
        authNetwork,
        chainId,
        clientIdentifier,
        isMobileSDK,
        isHashedMessage
    }:any){
        this.chainId = convertToNumber(chainId);
        this.clientIdentifier = clientIdentifier;
        this.authNetwork = authNetwork;
        this.initializeWebSocket();
        await this.initializeTorus();
        this.isInitialized = true;
        this.isMobileSDK = isMobileSDK;
        this.isHashedMessage = isHashedMessage;
        if((window as any).top){
            (window as any).top.postMessage({
                'call':'init',
                'retVal': {isInitalized:true}
            }, '*');
        }
        (window as any).clientIdentifier = clientIdentifier;
    }

    async handleIncompleteLogin(
        idToken:any, email:any, clientIdentifier:any,) {
        console.log('handleIncompleteLogin',
                    email, clientIdentifier);
        let jwtTokenData:any = await customLoginJWT( clientIdentifier, idToken);
        let jwtToken = jwtTokenData.data.jwt
        let torusKeyDetails:any;
        console.log('email boys', email);
        try {
          torusKeyDetails = await this.torusdirectsdk?.getTorusKey(
            'glipandroid',
            email,
            { verifier_id: email },
            jwtToken
          );
          console.log('torusKeyDetails', torusKeyDetails);
          
        } catch(e) {
          console.log(e)
          return
        }
        let newWallet = await getNewWallet(
          torusKeyDetails.privateKey);        
        let signer = getSigner(newWallet.privateKey)
        let torusSigner = getSigner(torusKeyDetails.privateKey);
        let signature = await signer.signMessage(idToken);
        let torusSignature = await torusSigner.signMessage(idToken);

        let glipggToken;
        console.log('state.clientId', clientIdentifier);
        try {
          let tokenData:any = await customLoginBackend( clientIdentifier, signature, torusSignature, idToken);
          glipggToken =  tokenData.data;
        } catch(e){
          console.log(e)
          return
        }
        
        console.log('user saved in backened')
        
        let mnemonic = newWallet.mnemonic.phrase
        
        saveLoginDetails({
          privateKey: newWallet.privateKey,
          address: newWallet.address,
          mnemonic: mnemonic,
          userInfo: {
            email: email,
            publicAddress: newWallet.address
          }
        }, glipggToken);
    }

    async initFromURL(){
        const urlParams = new URLSearchParams(window.location.search);
        let chainId = convertToNumber(urlParams.get('chainId'));
        let clientIdentifier = urlParams.get('clientIdentifier');
        let isMobileSDK:boolean|string|null = urlParams.get('isMobileSDK');
        let socketUUID = urlParams.get('socketUUID');
        let isHashedMessage = urlParams.get('isHashedMessage');
        console.log('socketUUID', socketUUID);
        if(!isMobileSDK){
            isMobileSDK = false;
        }
        if(socketUUID){
            console.log('socketUUID', socketUUID);
            this.socketUUID = socketUUID;
        }
        else{
            this.socketUUID = '';
        }
        await this.init({
            authNetwork: '',
            chainId,
            clientIdentifier,
            isMobileSDK,
            isHashedMessage
        })
    }
    
    initializeWebSocket(){
        console.log('Initializing websocket');
        if(this.socketUUID === ''){
            return;
        }
        console.log('Initializing websocket legend');
        console.log('roomID', `${this.socketUUID}`);
        const uuid = uuidv4();
        const socket = io(WEB_SOCKET_URI, {
            transports: ['websocket'],
            query: {roomId:`${uuid}`}
        });
        this.connectedSocket = socket;
        socket.on('connect', () => {
            console.log('connected to socket');
            socket.on('message', (data: any) => {
                if(data.type === "onBidWin"){}
            });
            socket.on('data', (data) => {
            });
        });        
    }
    
    async initializeTorus(){
        try {
            this.torusdirectsdk = new TorusSdk({
                baseUrl: BASE_URL,
                enableLogging: true,
                network: 'cyan', // details for testnet.
                uxMode: "redirect",
                redirectPathName: ''
            });
            await this.torusdirectsdk.init({
                skipSw: true,
                skipPrefetch: true
            });
        } catch (error) {
            console.error(error, "mounted caught");
        }
    }
    
    async login({loginType, lastLocation}:any){
        console.log('loginType', loginType);
        const glipRedirectURL = `https://glip.gg/wallet-login/`;
            const glipGoogleOpts = {
                'scope': 'https://www.googleapis.com/auth/userinfo.profile+https://www.googleapis.com/auth/userinfo.email',
                'redirect_uri': glipRedirectURL,
                client_id:'373196446500-ojt3ko1ghis9pritfhhogohlotut2hv6.apps.googleusercontent.com',
            };
            const currState = {
                lastLocation: lastLocation,
                clientIdentifier: '62fd0e1b5f653536e9c657a8',
            };
        const currOpts = glipGoogleOpts;
            let currStateString = JSON.stringify(currState);
            //url encode the state
            currStateString = encodeURIComponent(currStateString);
        const GOOGLE_OAUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?scope=${currOpts['scope']}&response_type=code&redirect_uri=${currOpts.redirect_uri}&client_id=${glipGoogleOpts.client_id}&access_type=offline&state=${currStateString}`;
        (window as any).open(GOOGLE_OAUTH_URL, "_self");
    };
    
    isConnected(){
        let loginInformation = getGlipWalletData();
        if(!loginInformation){
            // Return false
            console.log("Not connected");
            if(isIframeWindow()){
                (window as any).top.postMessage({
                    'call':'isConnected',
                    'retVal': false
                }, '*');
            }
            return false;
        }
        if(isIframeWindow()){
            (window as any).top.postMessage({
                'call':'isConnected',
                'retVal': true
            }, '*');
        }
        return true;
    }

    async getUserInfo(){
        let userData = getGlipUserData();
        let glipggToken:any = localStorage.getItem(GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY);
        if(!userData || !glipggToken){
            if(isIframeWindow()){
                (window as any).top.postMessage({
                    'call':'getUserInfo',
                    'errorVal': 'User not logged in'
                }, '*');
            }
            return;
        }
        glipggToken = JSON.parse(glipggToken);
        let googleIdToken = localStorage.getItem(
            'gg-idToken');
        let returnableUserInfo = {
            'name': userData.userInfo['name'],
            'profileImage': userData.userInfo['profileImage'],
            'email': userData.userInfo['email'],
            'glipAccessToken': glipggToken.accessToken,
            'googleIdToken': googleIdToken
        }
        let retval = {
            'userInfo': returnableUserInfo,
            'publicAddress': userData.userInfo.publicAddress
        };
        if(isIframeWindow()){
            (window as any).top.postMessage({
                'call':'getUserInfo',
                'retVal': {
                    ...returnableUserInfo,
                    'publicAddress': userData.userInfo.publicAddress
                }
            }, '*');
        }
        return retval;
    };
    
    getSigner = (privKey:any) => {
        console.log(privKey, "privKey");
        let wallet = new ethers.Wallet(privKey)
        return wallet;
    }    
    
    async logout () {
        localStorage.clear();
        localStorage.removeItem(WALLET_INFO_STORAGE_KEY);
        localStorage.removeItem(USER_INFO_STORAGE_KEY);
        localStorage.removeItem(GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY);
        localStorage.removeItem('MNEMONIC');
        localStorage.removeItem('OLD_WALLET_DETAILS');
        if(isIframeWindow()){
            (window as any).top.postMessage({
                'call':'logout',
                'retVal': true
            }, '*');
        }        
        // TODO: Remove this.
        const urlParams = new URLSearchParams(window.location.search);
        let deepLinkURL = urlParams.get('redirect_scheme');
        if(!isIframeWindow()){
            if (deepLinkURL) {
                (window as any).location = `${deepLinkURL}://loggedOut`;
            }
            else{
                (window as any).location = 'glipwallet://loggedOut'
            }
        }
    };
    
    async loginUserWithIdToken({loginType, userInfo}:any){
        const verifier = VERIFIER_DICT[loginType]['testnet']
        let torusKeyDetails:any = await this?.torusdirectsdk?.getTorusKey(
            verifier,
            userInfo['id'],
            {verifier_id: userInfo['id']},
            userInfo['idToken']
        );
        let signer = this.getSigner(torusKeyDetails.privateKey);
        let glipggToken = await loginUserBackend(
            (this.clientIdentifier as string),
            userInfo['accessToken'],
            signer
        );
        saveLoginDetails(torusKeyDetails, glipggToken);
    }

    async getGlipSigner(){
        let walletDetails:any = getGlipWalletData();
        let provider = await this.getProvider();
        let signer = this.getSigner(walletDetails.privateKey);
        return signer.connect(provider);
    }
    
    async getProvider() {
        const provider = await getInternalProvider((this.chainId as number));
        return provider;
    }

    getWalletID(){
        let glipggToken:any = localStorage.getItem(GLIP_BACKEND_TOKEN_INFO_STORAGE_KEY);
        if(!glipggToken){
            return;
        }
        glipggToken = JSON.parse(glipggToken);
        if(!glipggToken.id){
            return;
        }
        if(isIframeWindow()){
            (window as any).top.postMessage({
                'call':'getWalletID',
                'retVal': glipggToken.id
            }, '*');
        }
        return glipggToken.id
    }

    async getTransactionService(){
        if(!this.internalTransactionService){
            this.internalTransactionService = new InternalTransactionService({
                signer:await this.getGlipSigner(),
                provider:await this.getProvider(),
                connectedSocketConnection: (this.connectedSocket as Socket),
                isMobileSDK:this.isMobileSDK,
                socketUUID: this.socketUUID
            });            
        }
        return this.internalTransactionService;
    }

    async getMessageSigningService(){
        if(!this.internalMessageSigningService){
            this.internalMessageSigningService = new InternalMessageSigningService({
                signer:await this.getGlipSigner(),
                provider:await this.getProvider(),
                connectedSocketConnection: (this.connectedSocket as Socket),
                isMobileSDK:this.isMobileSDK,
                socketUUID: this.socketUUID,
                isHashedMessage: this.isHashedMessage
            });            
        }
        return this.internalMessageSigningService;
    }
}

const glipWalletGlobal = new WalletService();
(window as any).glipWalletGlobal = glipWalletGlobal;

window.addEventListener("message", (event) => {
    if(event.data.call === 'init'){
        if(event.data.retVal){
            return;
        }
        glipWalletGlobal.init(event.data.params);
    }
    else if(event.data.call === 'login'){
        glipWalletGlobal.login(event.data.params);
    }
    else if(event.data.call === 'getUserInfo'){
        glipWalletGlobal.getUserInfo();
    }
    else if(event.data.call === 'getWalletID'){
        glipWalletGlobal.getWalletID();
    }
    else if(event.data.call === 'isConnected'){
        glipWalletGlobal.isConnected();
    }
    else if(event.data.call === 'loginWithIdToken'){
        glipWalletGlobal.loginUserWithIdToken(event.data.params);
    }
    else if(event.data.call === 'logout'){
        glipWalletGlobal.logout();
    }
}, false);

export default glipWalletGlobal;

